module.exports = __webpack_public_path__ + "static/media/reset.7e8dd8a4.svg";